import { Component, OnInit, ViewChild, Input, Output, ElementRef, EventEmitter } from '@angular/core';
import { AbstractControl, FormControl, FormBuilder, Validators, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { ValidationService } from '../../../app/validation.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { HttpClientModule, HttpClient, HttpRequest, HttpResponse, HttpEventType } from '@angular/common/http';
import { Subscription } from 'rxjs-compat/Subscription';
import { FileUploader, FileSelectDirective } from 'ng2-file-upload';
import  moment from 'moment-timezone';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
export interface Client {
  value: string;
  viewValue: string;
}


@Component({
  selector: 'app-create-site-incharge',
  templateUrl: './create-site-incharge.component.html',
  styleUrls: ['./create-site-incharge.component.scss'],
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule,MatButtonModule]
})
export class CreateSiteInchargeComponent implements OnInit {
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL+'uploads/';
  public registerUserUrl = BaseUrlConstantsService.REGISTER_USERS;
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public imageUpdateInfoUrl = BaseUrlConstantsService.UPDATE_IMAGE_INFO;
  public editUserUrl = BaseUrlConstantsService.EDIT_USER_INFO;
  public uForm: any;
  public countryNames: any;
  public countryname: any;
  public pageType: string;
  msgColor = "red";
  message = ""
  public maxLength = 0;
  public allCitys: any;
  public pageRef: any;
  public selectedCountry: any;
  public showUpdateBtn: boolean;
  public showEditUsertxt: string;
  public showViewLicense: boolean;
  public states: any = [];
  public showSavebtn: boolean;
  public options: FormGroup;
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public url: any;
  public userId: any;
  public id: any;
  public showCancelBtn: boolean;
  public updateDataReq: any = false;
  public percentDone = 0;
  public uploadSuccess: boolean;
  public _imgUrl: any = "./assets/img-new/client.png";
  public fileName = '';
  public _adminUserId: any;
  defaultFlgONphone: string;
  public _imageId = null;
  public timeZones: any = [];
  public uploader: FileUploader;
  public clients: Client[] = [
    { value: 'steak-0', viewValue: 'Mario Speedwagon' },
    { value: 'pizza-1', viewValue: 'Petey Cruiser' },
    { value: 'tacos-2', viewValue: 'Anna Sthesia' },
    { value: 'tacos-2', viewValue: 'Paul Molive' },
  ];
  public breadcrumbsArray: any = [{
    page_ref: 'admin-users',
    page_title: 'account managers'
  }, {
    page_ref: 'admin-create-users',
    page_title: 'add account manager'
  }];
  imagePath: any;


  constructor(
    private http: HttpClient,
    public router: Router,
    private service: BackendApiService,
    private changeService: ChangeUsersService,
    public activeRoute: ActivatedRoute,
    public dialog: MatDialog,
    private formBuilder: FormBuilder) {
      this.countryname = localStorage.getItem('country');
      switch(this.countryname){
        case 'Canada' :
          this.countryname= 'ca';
          break;
        case 'India':
          this.countryname = 'in';
          break;
        case 'United States':
          this.countryname = 'us';
          break;
      }
    this.uploader = new FileUploader({ url: BaseUrlConstantsService.IMAGE_UPLOAD, itemAlias: 'photo' });
    activeRoute.queryParams.subscribe(params => {
      this.pageType = params[`pageRef`];
      this._adminUserId = params[`adminUserId`];
      if (this._adminUserId !== undefined) {
        this.breadcrumbsArray[1].page_title = 'Edit Site Incharge';
      }
      if (this.pageType === `admin-user`) {
        this.showUpdateBtn = true;
        this.showEditUsertxt = 'Edit Site Incharge';
        this.showViewLicense = true;
        this.showSavebtn = false;
      } else {
        this.showUpdateBtn = false;
        this.showSavebtn = true;
        this.showEditUsertxt = 'Create Site Incharge';
        this.showViewLicense = false;
      }
    });
  }


  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  saveUserMethod() { }

  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  showProfileImage() {
    if(this._adminUserId != undefined){
      this.service.getData(this.imageUploadUrl + "/" + this._adminUserId).then(response => {
        if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
          this._imgUrl = this.imageBaseV2Url+ JSON.parse(JSON.stringify(response)).data.body[0].relative_url;
        }
      });
    }
  }


  onChangePhoneNo(number) {
    const phoneNumber = number.trim();
    const countryCodeLength = phoneNumber.length - 10;
    const components = {
      IDDCC: phoneNumber.substr(0, countryCodeLength),
      NN: phoneNumber.substr(countryCodeLength, phoneNumber.length)
    };
    if (components.IDDCC === '+1' || components.IDDCC === '+91') {
      if (components.NN.length === 10) {
        this.message = "";
      } else {
        this.message = "Phone number seems invalid!";
      }
    } else {
      this.message = "Phone number seems invalid!";
    }
  }


  removeUserImage() {
    this.service.getData(this.imageUploadUrl + "/remove/" + this._adminUserId).then(response => {
      this._imgUrl = "./assets/img-new/default_user.png";
      this.service.showSuccess('Removed successfully.');
    });
  }

  upload(files: any) {
    if (files[0].name !== undefined && files[0].name === '') {
      this.fileName = '';
    } else {
      this.showCancelBtn = true;
      this.fileName = files[0].name;

      if (this.showEditUsertxt !== 'Create Site Incharge') {
        this.uploader.uploadAll();
        this.uploader.onProgressItem = (progress: any) => {
          this.percentDone = progress['progress'];
        };
      } else {
        var reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
          this._imgUrl = reader.result;
        }
      }
    }
  }



  private subscription: Subscription = new Subscription();

  uploadAndProgress(files: any, signedRequest, imageurl, userId, cId) {
    const formData = new FormData();
    this.subscription.add(this.http.put(signedRequest, files[0], { reportProgress: true, observe: 'events' })
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.percentDone = Math.round(100 * event.loaded / event.total);
        } else if (event instanceof HttpResponse) {
          this.showCancelBtn = false;
          this.fileName = '';
          this.uploadSuccess = true;
          this._imgUrl = imageurl;
        }
      }));
  }
  cancelClick() {
    this.subscription.unsubscribe();
    this.fileName = '';
    this.showCancelBtn = false;
  }

  openListPage(){
    this.router.navigate(['/site-incharge']);
  }


  ngOnInit() {
    this.timeZones = moment.tz.names();
    this.updateDataReq = false;
    this.uForm = this.formBuilder.group({
      full_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      email: new FormControl('', ValidationService.emailValidator),
      phone_number: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      address_line1: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      address_line2: new FormControl(''),
      country_name_: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      state_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      timezone: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      city_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      postcode: new FormControl('')
    });
    this.service.load().then(data => {
      this.countryNames = JSON.parse(JSON.stringify(data)).countries;
    });

    this.showProfileImage();

    this.uploader.onBuildItemForm = (item, form) => {
      form.append('token', localStorage.getItem('token'));
      form.append('user_id', this._adminUserId);
    };
    this.uploader.onAfterAddingFile = (file) => { file.withCredentials = false; };
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      if (status === 200) {
        if(this._adminUserId != undefined){
          this.service.getData(this.imageUploadUrl + "/" + this._adminUserId).then(response => {
            if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
              this._imgUrl = this.imageBaseV2Url+JSON.parse(JSON.stringify(response)).data.body[0].relative_url;
              this.fileName = '';
              this.service.showSuccess('Saved successfully');
            }
          });
        }

      } else {
        this.service.showError('Upload unsuccessfully');
      }
    };

    if (this._adminUserId != undefined) {
      this.getAdminUserData()
    }
  }

  onChange(deviceValue) {
    let pullIndex;
    this.selectedCountry = deviceValue;
    if (deviceValue === 'Canada') {
      pullIndex = 1;
      this.maxLength = 6;
    } else if (deviceValue === 'United States') {
      pullIndex = 0;
      this.maxLength = 5;
    } else {
      pullIndex = 2;
      this.maxLength = 6;
    }
    this.service.load().then(data => {
      this.states = JSON.parse(JSON.stringify(data)).countries[pullIndex].states;
    });
  }

  addClient() {
    this.router.navigate(['/admin-create-users']);
  }

  showLicense(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '650px'
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
  getAdminUserData() {
    this.updateDataReq = true;
    const body = {
      id: this._adminUserId
    };
    this.changeService.loader(true);
    this.service.getData(this.editUserUrl + "/" + Math.floor(Math.random() * 90 + 10) + this._adminUserId + Math.floor(Math.random() * 9000 + 1000) ).then(response => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(response)).data.status === 'success') {
        const resp = JSON.parse(JSON.stringify(response)).data.body[0];
        switch (resp.country) {
          case 'Canada':
            this.defaultFlgONphone = "'" + 'ca' + "'";
            break;
          case 'India':
            this.defaultFlgONphone = "'" + 'in' + "'";;
            break;
          case 'United States':
            this.defaultFlgONphone = "'" + 'us' + "'";;
            break;
        }
        if (resp.profile_image != null) {
          this._imgUrl = resp.profile_image;
        }
        this._imageId = resp.image_id;
        this.onChange(resp.country);

        this.uForm = this.formBuilder.group({
          full_name: new FormControl(resp.full_name, [Validators.required, this.noWhitespaceValidator]),
          email: new FormControl(resp.email, ValidationService.emailValidator),
          phone_number: new FormControl(resp.phone_no, [Validators.required, this.noWhitespaceValidator]),
          address_line1: new FormControl(resp.address_1, [Validators.required, this.noWhitespaceValidator]),
          address_line2: new FormControl(resp.address_2),
          country_name_: new FormControl(resp.country, [Validators.required, this.noWhitespaceValidator]),
          timezone: new FormControl(resp.timezone, [Validators.required, this.noWhitespaceValidator]),
          state_name: new FormControl(resp.state, [Validators.required, this.noWhitespaceValidator]),
          city_name: new FormControl(resp.city, [Validators.required, this.noWhitespaceValidator]),
          postcode: new FormControl(resp.postal_code),
        });
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }
  onCountryChange(num){

  }
  async saveUser() {
    let _imgId = null;
    if (this.uploadSuccess) {
      _imgId = this.id;
    }
    else if (this._imageId != null) {
      _imgId = this._imageId;
    }
    let reqObj = {
      client_id: localStorage.getItem("user_id"),
      full_name: this.uForm.value.full_name,
      phone_no: this.uForm.value.phone_number,
      address_1: this.uForm.value.address_line1,
      address_2: this.uForm.value.address_line2,
      country: this.uForm.value.country_name_,
      state: this.uForm.value.state_name,
      city: this.uForm.value.city_name,
      timezone: this.uForm.value.timezone,
      postal_code: this.uForm.value.postcode,
      email: this.uForm.value.email,
      role: 'site_incharge'
    }
    if (_imgId != null) {
      reqObj['image_id'] = _imgId;
    }
    if (this.showEditUsertxt === 'Create Site Incharge') {
      if (this.uForm.dirty && this.uForm.valid) {
        const body = reqObj;
        this.service.postData(this.registerUserUrl, body).then(res => {
          if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
            const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
            this.service.showError(msgErr);
          } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
            if (this.fileName !== '') {
              this._adminUserId = JSON.parse(JSON.stringify(res)).data.user_id;
              this.fileName;
              this.uploader.uploadAll();
              this.uploader.onProgressItem = (progress: any) => {
                this.percentDone = progress['progress'];
                if (this.percentDone === 100) {
                  this.service.showSuccess('User registered successfully');
                  this.router.navigate(['/site-incharge']);
                }
              };
            } else {
           this.service.showSuccess('User registered successfully');
            this.router.navigate(['/site-incharge']);
            }

          } else {
            this.service.showError('Something went wrong.');
          }
        });
      }
    } else {
      let reqObject = {
        full_name: this.uForm.value.full_name,
        phone_no: this.uForm.value.phone_number,
        address_1: this.uForm.value.address_line1,
        address_2: this.uForm.value.address_line2,
        country: this.uForm.value.country_name_,
        state: this.uForm.value.state_name,
        city: this.uForm.value.city_name,
        timezone: this.uForm.value.timezone,
        postal_code: this.uForm.value.postcode,
        email: this.uForm.value.email,
        role: 'site_incharge'
      }
      if (_imgId != null) {
        reqObject['image_id'] = _imgId;
      }
      const body = reqObject;
      this.service.putData(this.editUserUrl + "/" + (Math.floor(Math.random() * 90 + 10) + this._adminUserId + Math.floor(Math.random() * 9000 + 1000)), body).then(res => {
        if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.service.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.service.showSuccess('User updated successfully');
          this.router.navigate(['/site-incharge']);
        } else {
          this.service.showError('Something went wrong.');
        }
      });
    }
  }
}
